<div class="container mb-2">
  <app-passengers-resume [passengers]="passengers"> </app-passengers-resume>

  <!-- Flights -->
  <div class="weight-medium pb-1">
    <em class="mdi mdi-airplane has-text-grey is-size-6"></em>
    {{ flightsTitle }}
  </div>

  <!-- Header -->
  <div class="columns is-size-7 mb-1pt weight-medium">
    <div class="column is-3 pb-0">
      {{ 'itinerary-info.flight.arrival-date' | translate }}
    </div>
    <div class="column pb-0">
      {{ 'itinerary-info.flight.departure' | translate }}
    </div>
    <div class="column pb-0">
      {{ 'itinerary-info.flight.arrival' | translate }}
    </div>
  </div>

  <div class="columns is-size-6 mb-1pt" *ngFor="let flight of flights">
    <div class="column is-3 pb-1">
      <div>{{ 'itinerary-info.flight.flight' | translate }} {{ flight.number }}</div>
      <div>
        {{ flight.departureDate | customDate | date | localizedDate : 'EEE d MMM y' : '+0000' }}
      </div>
    </div>
    <div class="column pb-1">
      <div>
        <span class="weight-medium">{{ flight.departureLocation.code }} </span>
        <span>{{ flight.departureLocation.name }}</span>
      </div>
      <div class="is-capitalized">
        {{ flight.departureLocation.airportName | lowercase }}
      </div>
    </div>
    <div class="column pb-1">
      <div>
        <span class="weight-medium">{{ flight.arrivalLocation.code }} </span>
        <span>{{ flight.arrivalLocation.name }}</span>
      </div>
      <div class="is-capitalized">
        {{ flight.arrivalLocation.airportName | lowercase }}
      </div>
    </div>
  </div>

  <ng-content select="[action]"></ng-content>
</div>
